import { render, staticRenderFns } from "./editTypeWorkLeave.vue?vue&type=template&id=5a3e21dd&scoped=true&"
import script from "./editTypeWorkLeave.vue?vue&type=script&lang=js&"
export * from "./editTypeWorkLeave.vue?vue&type=script&lang=js&"
import style0 from "./editTypeWorkLeave.vue?vue&type=style&index=0&id=5a3e21dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e21dd",
  null
  
)

export default component.exports